import React from 'react';

import Classes from './Skeleton.module.scss';

import SkeletonBase from './SkeletonBase';

type TProps = {
  type?: 'short' | 'long';
  withAnimation?: boolean;
};

const getTypeClassName = (type: 'short' | 'long') => {
  switch (type) {
    case 'short':
      return Classes.Short;
    case 'long':
    default:
      return Classes.Long;
  }
};

const TextSkeleton = ({ type = 'long', withAnimation }: TProps) => {
  const typeClass = getTypeClassName(type);
  return <SkeletonBase className={`${Classes.TextSkeleton} ${typeClass}`} withAnimation={withAnimation} />;
};

export default TextSkeleton;
